import {
  deleteAlertLevelById,
  deleteAlertTemplateById,
  getAlertLevelById,
  getAlertLevels,
  getAlertTemplateById,
  getAlertTemplates,
  patchAlertLevelById,
  patchAlertTemplateById,
  saveAlertLevel,
  saveAlertTemplate,
} from 'frontend/communications/alerts'

const stateObj = {
  alertTemplates: [],
  alertLevels: [],
  filters: {},
  creators: [],
  pilots: [],
  participants: [],
}

const getters = {
  getActiveAlertTemplates (state) {
    return state.alertTemplates.filter(alertTemplate => alertTemplate.enabled)
  },
  getAlertTemplateById: (state) => (id) => {
    return state.alertTemplates.find(alertTemplate => alertTemplate.id == id)
  },
  getActiveAlertLevels (state) {
    return state.alertLevels.filter(alertLevel => alertLevel.enabled)
  },
  getAvailableNextAlertLevels: (state) => (currentId) => {
    const usedAlertIds = state.alertLevels.filter(
      alertLevel => alertLevel.next_level != null && alertLevel.id != currentId
    ).map(alertLevel => { return alertLevel.next_level })
    return state.alertLevels.filter((alertLevel) =>
      alertLevel.enabled && !usedAlertIds.includes(alertLevel.id)
    )
  },
  getAlertLevelById: (state) => (id) => {
    return state.alertLevels.find(alertLevel => alertLevel.id == id)
  },
}

const mutations = {
  setAlertTemplates (state, value) {
    state.alertTemplates = value
  },
  addAlertTemplate (state, value) {
    const index = state.alertTemplates.findIndex(alertTemplate => alertTemplate.id == value.id)
    index >= 0 ? state.alertTemplates.splice(index, 1, value) : state.alertTemplates.push(value)
  },
  removeAlertTemplateById (state, value) {
    state.alertTemplates = state.alertTemplates.filter(alertTemplate => alertTemplate.id !== value.id)
  },
  updateAlertTemplateById (state, value) {
    const index = state.alertTemplates.findIndex(alertTemplate => alertTemplate.id == value.id)
    state.alertTemplates.splice(index, 1, value)
  },
  setAlertLevels (state, value) {
    state.alertLevels = value
  },
  addAlertLevel (state, value) {
    const index = state.alertLevels.findIndex(alertLevel => alertLevel.id == value.id)
    index >= 0 ? state.alertLevels.splice(index, 1, value) : state.alertLevels.push(value)
  },
  removeAlertLevelById (state, value) {
    state.alertLevels = state.alertLevels.filter(alertLevel => alertLevel.id !== value.id)
  },
  updateAlertLevelById (state, value) {
    const index = state.alertLevels.findIndex(alertLevel => alertLevel.id == value.id)
    state.alertLevels.splice(index, 1, value)
  },
}

const actions = {
  async fetchAlertTemplates ({ commit }) {
    const response = await getAlertTemplates()
    commit('setAlertTemplates', response)
    return response
  },
  async getAlertTemplateById ({ commit }, payload) {
    const { id } = payload
    const response = await getAlertTemplateById(id)
    commit('addAlertTemplate', response)
    return response
  },
  async addAlertTemplate ({ commit }, payload) {
    const response = await saveAlertTemplate(payload)
    commit('addAlertTemplate', response)
    return response
  },
  async removeAlertTemplateById ({commit}, payload) {
    const { id } = payload
    await deleteAlertTemplateById(id)
    commit('removeAlertTemplateById', { id })
  },
  async updateAlertTemplateById ({commit}, payload) {
    const {id, data} = payload
    const response = await patchAlertTemplateById(id, data)
    commit('updateAlertTemplateById', response)
    return response
  },
  async fetchAlertLevels ({ commit }) {
    const response = await getAlertLevels()
    commit('setAlertLevels', response)
    return response
  },
  async getAlertLevelById ({ commit }, payload) {
    const { id } = payload
    const response = await getAlertLevelById(id)
    commit('addAlertLevel', response)
    return response
  },
  async addAlertLevel ({ commit }, payload) {
    const response = await saveAlertLevel(payload)
    commit('addAlertLevel', response)
    return response
  },
  async removeAlertLevelById ({commit}, payload) {
    const { id } = payload
    await deleteAlertLevelById(id)
    commit('removeAlertLevelById', { id })
  },
  async updateAlertLevelById ({commit}, payload) {
    const {id, data} = payload
    const response = await patchAlertLevelById(id, data)
    commit('updateAlertLevelById', response)
    return response
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
